import { useEffect, useState } from "react";
import { StyledTable } from "../Table.styled"
import { Table } from "../../../models/table";
import { CircularProgress, Typography } from "@mui/material";
import { useErrorBoundary } from "react-error-boundary";
import { handleApiErrors } from "../../../services/errorHandling";
import { useAddCustomTableMutation, useEditCustomTableMutation, useGetCustomTablesQuery } from "../../../redux/api/custom-tables.api";
import CustomTableOptions from "./custom-table-options/CustomTableOptions";


function CustomTables() {

  const { showBoundary } = useErrorBoundary();

  const { 
    data: customTables, 
    isLoading: isFetchingCustomTables 
  } = useGetCustomTablesQuery();

  const [editCustomTable] = useEditCustomTableMutation();
  const [addCustomTable] = useAddCustomTableMutation();

  const [customTablesCopy, setCustomTablesCopy] = useState<Table[]>();
  const [selectedTable, setSelectedTable] = useState<Table | undefined>();
  const [action, setAction] = useState<string>("browse")


  useEffect(() => {
    if(customTables){
      console.log("customTables", customTables);
      setCustomTablesCopy(customTables);
    }
  }, [customTables]);


  /**
   * save the edited custom table in the state
   * @param event 
   * @param tableChanged 
   */
  function apdateState(event: React.ChangeEvent<HTMLInputElement>, tableChanged: Table): void{

    const customTablesToUpdate = customTablesCopy?.map(table => table.id === tableChanged.id ? { ...tableChanged, name: event.target.value } : table);
    setCustomTablesCopy(customTablesToUpdate);

  }


  /**
   * save the edited custom table in db and store
   * @param table 
   */
  const saveInput = async (table: Table) => {

    try {
      await editCustomTable(table);
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
    
  }


  /**
   * add a new custom table
   */
  async function addNewCustomTable(): Promise<undefined>{
    try {
      const tableIndex: number = (customTablesCopy?.length ?? 0) + 1;
      await addCustomTable(tableIndex);
    } 
    
    catch (error) {
      handleApiErrors(error, showBoundary);
    }
  }


  /**
   * handling return back inside the component
   */
  function returnBack() {

    if (selectedTable?.name) {
      setSelectedTable(undefined);
    }
  }

  return (
    <StyledTable>
      { isFetchingCustomTables && <CircularProgress color="inherit" sx={{ display: "block", margin: "auto", padding: 4 }} /> }

      { !isFetchingCustomTables && customTablesCopy && !selectedTable && (
        <>
          <Typography variant="h3" className="title">
            טבלאות פנימיות
          </Typography>
          <div className="table-container">
            <table>
              <tbody>
                {
                  customTablesCopy.map((table, index) => (
                    <tr key={index}>
                      <td>{table.index}.</td>
                      <td className="expand">
                        {action === 'edit' ?
                          <input value={table.name || ""} onChange={(e) => { apdateState(e, table) }} onBlur={() => { saveInput(table) }} /> :
                          <a className="clickable" onClick={() => { setSelectedTable(table) }}>{table.name}</a>
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </table>
          </div>
          <div className="buttons">
            {action === 'browse' ? <button onClick={() => { setAction('edit') }}>עריכה</button> : <button onClick={() => { setAction('browse') }}>סיום עריכה</button>}
            <button onClick={addNewCustomTable}>הוספת טבלה</button>
          </div>
        </>
      )}

      { selectedTable && (
        <CustomTableOptions customTable={selectedTable} returnBack={returnBack}/>
      )}

    </StyledTable>
  )
}

export default CustomTables